import { render, staticRenderFns } from "./OptionSizeSettings.vue?vue&type=template&id=cd436c2a&scoped=true"
import script from "./OptionSizeSettings.vue?vue&type=script&lang=js"
export * from "./OptionSizeSettings.vue?vue&type=script&lang=js"
import style0 from "./OptionSizeSettings.vue?vue&type=style&index=0&id=cd436c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd436c2a",
  null
  
)

export default component.exports